module.exports = "<app-archive-edit-general archive=$ctrl.archive on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)> </app-archive-edit-general> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/archive/edit/general/template.html
// module id = 396
// module chunks = 0